import React from 'react'

const Home = () => {
  return (
    <div className="fixed z-10 text-white md:left-pad bottom-pad right-pad w-1/2 md:w-3/12 word-break mr-10 md:mr-20 mb-10 md:mb-20 text-xs md:text-xl text-right md:text-left md:ml-10">
      <p>
        Apaixonado por tecnologia, lógica, jogos e movido pela curiosidade de entender como as coisas funcionam por trás
        da tela.
      </p>
    </div>
  )
}

export default Home
